import React from "react";
import PropTypes from "prop-types";

class UserRoleSelect extends React.Component {
  state = {
    userRole: "all"
  };

  onChange = e => {
    this.setState({ userRole: e.target.value });
    setTimeout(
      function() {
        this.props.newUserRoleCallback(this.state.userRole);
      }.bind(this),
      300
    );
  };

  render() {
    return (
      <div className="col-md-3 col-xs-12">
        <select
          className="form-control"
          title="User Role"
          value={this.state.userRole}
          onChange={e => this.onChange(e)}
        >
          <option value={"all"} defaultValue>All Employees</option>
          <option value={"admin"}>Admin Employees</option>
          <option value={"super_admin"}>Super Admin Employees</option>
        </select>
      </div>
    );
  }
}

UserRoleSelect.propTypes = {
  newActiveCallback: PropTypes.func
};

export default UserRoleSelect;
